<template>
  <SummaryCard
    :title="$t('views.portfolio.topPortfolioDividends.title')"
    :infoText="$t('views.portfolio.topPortfolioDividends.info')"
    :loading="loadingSummary"
    :value="totalDividendWithReturnBaseCurrency"
    :valueCurrency="user.baseCurrency"
    :subtitle="
      totalDividendYield || totalDividendYield === 0
        ? `${$t('views.portfolio.topPortfolioDividends.subtitle')}: ${totalDividendYield}%`
        : ''
    "
  />
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import { getCurrencyValueAsString } from '@/lib/utils/currencies.js'
import SummaryCard from '@/views/components/dashboardDetail/summary/SummaryCard'

export default {
  components: { SummaryCard },
  props: {
    summary: {
      type: Object,
      default: () => {},
    },
    loadingSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState(['user']),
    totalDividendWithReturnBaseCurrency() {
      return get(this.summary, 'totalDividendWithReturnBaseCurrency', null)
    },
    totalDividendYield() {
      const value = get(this.summary, 'totalDividendYield', null)
      return getCurrencyValueAsString({
        value,
      })
    },
  },
}
</script>
